export const StatusType = {
  PENDING: 100,
  BACKLOG: 200,
  NEGOTIATION: 300,
  CANCEL: 400,
  ACCEPTED: 500,
  'IN PROGRESS': 600,
  CLOSED: 1000,
} as const

export const Category = {
  CKD: 'CKD',
  Part: 'Part',
  Engine: 'Engine',
} as const

export const depositStatusType = {
  '入金前': 'false',
  '入金済': 'true'
}  as const

export const OTHER_PARTS_PRODUCT_CODE = '990999'